// extracted by mini-css-extract-plugin
module.exports = {"root":"Separator_root__1dh7h"};